export default __webpack_public_path__ + "static/deepTissue-2b68df94e42d5a6df7f3f49b1109a0c6.jpg";